<template>
  <div style="height:100%">
    <div class="login-title">登录</div>
    <!-- 手机号 ios验证加pattern -->
    <div class="login-phone">
      <!-- if(value.length>11)value=value.slice(0,11) 判断11位 -->
      <input
        v-reset-page
        type="number"
        placeholder="请输入手机号码"
        oninput="if(value.length>11)value=value.slice(0,11)"
        pattern="[0-9]*"
        v-model.trim="phoneNuber"
        @input="handleWatch"
      />
    </div>
    <!-- 验证码 ios验证加pattern -->
    <div class="login-verify">
      <input
        v-reset-page
        type="number"
        placeholder="请输入验证码"
        pattern="[0-9]*"
        @input="handleWatch"
        v-model.trim="verifyCodeVal"
      />
      <span class="clearfix" @click="HandleCountdownClick" v-show="iscodeShow"
        >获取验证码</span
      >
      <span class="clearfix" style="color:#CCCCCC" v-show="!iscodeShow"
        >重新获取{{ time }}s</span
      >
    </div>
    <!-- 判断是否登录按钮置灰 -->
    <div :class="show ? 'btn' : 'btn2'" @click="handleLginBtnClick">登录</div>
    <!-- 用户协议 -->
    <div class="agreement">
      登录即视为您已阅读并同意协议
      <span style="color:#008CFF" @click="handleGopageUserAgreenment"
        >《用户服务协议》</span
      >
    </div>
  </div>
</template>
<script>
import { clearInterval } from "timers";
import { Toast } from "vant";
import { CheckPhone, sendCode, register, userAgreement } from "@/api/login";
import { getUrlParam } from "@/utils/parsing";
import wx from "weixin-js-sdk";
import { constants } from "crypto";
import { Get_openid } from "@/api/public";
export default {
  data() {
    return {
      time: 0,
      show: true,
      phoneNuber: "",
      verifyCodeVal: "",
      code: "",
      iscodeShow: true,
      isHaveGetCaptcha: false,
    };
  },
  mounted() {
    // alert('1111')
    sessionStorage.removeItem("loginInfo");
    // sessionStorage.removeItem  sessionStorage
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.fun, false); //false阻止默认事件
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.fun, false); //false阻止默认事件
  },

  methods: {
    handleWatch() {
      if (this.phoneNuber && this.verifyCodeVal) {
        this.show = false;
      } else {
        this.show = true;
      }
    },
    fun() {
      wx.closeWindow();
    },
    //点击获取验证码
    HandleCountdownClick() {
      // 转换成字符串
      let phoneNuber = this.phoneNuber.toString();
      // 判断手机号是否为空和小于11位
      if (!this.phoneNuber) {
        Toast("手机号不能为空");
      } else if (phoneNuber.length < 11) {
        Toast("长度不够11位");
      } else {
        // 后台进行验证手机号
        this.requestCheckPhone();
      }
    },
    // 请求微信服务器获得code方法
    // 点击登录
    handleLginBtnClick() {
      // 如果为true的话获取验证码,否则执行登录操作
      if (!this.isHaveGetCaptcha) {
        Toast("请获取验证码");
      } else {
        if (!this.verifyCodeVal) {
          Toast("请输入验证码");
        } else {
          this.requestRegister();
        }
      }
    },
    // 校验手机号
    requestCheckPhone() {
      let phoneNuber = this.phoneNuber;
      CheckPhone({ phone: phoneNuber }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.isHaveGetCaptcha = true;
          this.requestSendCode();
        }
        if (res.code == 10002) {
          //  this.isHaveGetCaptcha = false;
          Toast(res.message);
        }
      });
    },
    // 发送验证码
    requestSendCode() {
      //  this.$router.push({
      //     path: "/"
      //   });
      let phoneNuber = this.phoneNuber;
      sendCode({ phone: phoneNuber }).then((res) => {
        //console.log(res);
        if (res.code == 200) {
          this.sendCountdown();
        }
      });
    },
    getUrlKey(name) {
      //获取url 参数
      // alert("location.href code = "+"====="+location.href);
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    // 登录
    requestRegister() {
      let phoneNuber = this.phoneNuber;
      let verifyCodeVal = this.verifyCodeVal;
      let code = this.getUrlKey("code"); //sessionStorage.getItem("code");
      // alert("BBBBBBB code = "+code);
      if (verifyCodeVal) {
        this.isHaveGetCaptcha = true;
      }
      if (!code) {
        // alert("登录111")
        Toast("请刷新页面后再次登录");
        this.$router.push({
          path: "/login",
        });
      } else {
        // alert("登录22222")
        register({ phone: phoneNuber, code: verifyCodeVal, wxCode: code }).then(
          (res) => {
            if (res.code == 10002) {
              Toast(res.message);
              return false;
            }
            if (res.code == 200) {
              // alert("登录33333")
              sessionStorage.removeItem("code");
              // 将data转换成字符转
              // 为什么每次获取的时候sessionStroage没有覆盖掉
              let jsonLoginInfo = JSON.stringify(res.data);
              // 将数据存入到sessionStorage
              sessionStorage.setItem("loginInfo", jsonLoginInfo);
              if (res.data.role == 1) {
                this.$router.push({
                  path: "/",
                });
              }
              if (res.data.role == 0) {
                this.$router.push({
                  path: "/choosebar",
                });
              }
            } else {
              Toast(res.message);
              sessionStorage.removeItem("code");
              this.$router.push({
                path: "/login",
              });
            }
          }
        );
      }
    },
    // 发送验证码时倒计时
    sendCountdown() {
      this.iscodeShow = false;
      this.time = 60;
      let auth_timer = window.setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          window.clearInterval(auth_timer);
          this.iscodeShow = true;
        }
      }, 1000);
      this.$once("hook:beforeDestroy", function() {
        window.clearInterval(auth_timer);
      });
    },
    // 跳转到用户协议
    handleGopageUserAgreenment() {
      window.location.href =
        "https://kf.qingruilin.com.cn/admin/h5/get_user_agreement";
    },
  },
};
</script>

<style scoped lang="scss">
.login-title {
  width: 100%;
  height: 200px;
  line-height: 200px;
  padding: 0 25px;
  box-sizing: border-box;
  text-align: left;
  font-size: 30px;
  color: #333333;
}
// 手机号
.login-phone {
  width: 325px;
  height: 60px;
  // padding: 10px 0;
  // box-sizing: border-box;
  margin: 0 auto;
  border-bottom: 1px solid #eeeeee;
  input {
    display: inline-block;
    width: 100%;
    height: 50px;
    border: none;
    outline: none;
    color: #cccccc;
    font-size: 16px;
    &::-webkit-input-placeholder {
      color: #cccccc;
      font-size: 16px;
      padding-top: 5px;
    }
  }
}
// 验证
.login-verify {
  width: 325px;
  height: 60px;
  margin: 0 auto;
  border-bottom: 1px solid #eeeeee;
  input {
    display: inline-block;
    width: 170px;
    height: 50px;
    border: none;
    outline: none;
    float: left;
    color: #cccccc;
    font-size: 16px;
    &::-webkit-input-placeholder {
      color: #cccccc;
      font-size: 16px;
      padding-top: 5px;
    }
  }
  span {
    display: inline-block;
    width: 125px;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    color: #008cff;
    text-align: center;
    float: right;
  }
}
// 按钮
.btn {
  width: 350px;
  height: 44px;
  // background: -webkit-linear-gradient(left, #4BADF5, #398df7);
  background-color: #7dd6ff;
  opacity: 0.5;
  margin: 0 auto;
  border-radius: 22px;
  font-size: 16px;
  color: $white-color;
  line-height: 44px;
  margin-top: 50px;
  text-align: center;
}
.btn2 {
  width: 350px;
  height: 44px;
  background: -webkit-linear-gradient(left, #4badf5, #398df7);
  margin: 0 auto;
  border-radius: 22px;
  font-size: 16px;
  color: $white-color;
  line-height: 44px;
  margin-top: 50px;
  text-align: center;
}
// 协议
.agreement {
  width: 100%;
  text-align: center;
  font-size: 11px;
  color: #bbbbbb;
  margin-top: 168px;
}
</style>
<style lang="scss"></style>
